import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import { DEFAULT_BLOCK_STORAGE_LIMITS } from '@xver/utils/blockStorage';

export const PRICING_PRODUCTS_QUERY_KEY = 'api.v1.pricing.products';

export const PRICING_FALLBACK: Endpoints.v1.Pricing.ProductsResponseModel = {
    currency: 'THB',
    products: {
        container: {
            rates: {
                cpu_seconds: 0.0003,
                gib_seconds: 0.00005,
                http_requests_per_million: 20.0,
                volume_gb_monthly_rate: 4.0,
            },
            free_tier: { vcpu_seconds: 180_000, gib_seconds: 360_000, http_requests: 1_000_000 },
        },
        registry: { gb_hourly_rate: 1.5, free_storage_gb: 0.5 },
        bandwidth: { overage_gb_rate: 0.3 },
        backup: { gb_hourly_rate: 0.0025 },
        instance: { disk_addition_gb_monthly_rate: 5 },
        block_storage: { gb_monthly_rate: 4, ...DEFAULT_BLOCK_STORAGE_LIMITS },
    },
};

export function usePricingQuery() {
    return useQuery({
        queryKey: [PRICING_PRODUCTS_QUERY_KEY],
        queryFn: async () => Endpoints.v1.Pricing.getProductsPricing(),
        staleTime: 1000 * 60 * 60,
        retry: 2,
        retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 30000),
        placeholderData: PRICING_FALLBACK,
    });
}
